import { IconMoneybag, IconBookFilled, IconUsersGroup, IconClock } from "@tabler/icons-react"
import { icon } from "../functions/icons"
import { DropdownButton } from "../atoms/buttons"
import { HorizontalLayout } from "./layout"
import { IconAtom, IconAtom2 } from "../atoms/iconAtom"
export function KpiComp({ title, value = 0, percentage, data, icon2, editClass }) {
    return (
        <div className={`standard-rounded standard-border standard-padding standard-margin kpi-comp ${editClass}`}>
            <div className='horizontal'>
                <div className='vertical'>
                    <div className="horizontal">
                        <div className="standard-border standard-rounded small-icon" data-testid={'icon'}>{icon(icon2)}</div>
                        <p className="module-name">{title}</p>
                    </div>
                    <h2 className="module-value" style={value.length > 10?{height:"3rem", fontSize:"1.5rem"}:{}}>{value}</h2>
                    <div className='horizontal'><div>{(percentage > 0) ? icon("increase") : icon("decrease")}</div><p className="xsmall-text regular-bold grey-600">{percentage}</p></div>
                </div>
                {data}
            </div>
        </div>
    )
}

export function RapportKpiComp({ title, value, percentage, data, icon2, editClass, dropdownOptions, onSelectDropdown, onToggleGraph, isActive, unit }) {
    function formatUnit(unit) {
        switch (unit) {
            case 'count': return '';
            case 'percentage': return '%';
            case 'time': return 'min';
            default: return '';
        }
    }
    return (
        <div className={`standard-rounded standard-border standard-margin kpi-comp ${editClass}`}>
            <div className='vertical'>
                <div className="horizontal">
                    {/* <div className="standard-border standard-rounded small-icon" data-testid={'icon'}>{icon(icon2)}</div> */}
                    <p className="module-name standard-margin-right">{title}</p>
                    <div>{(percentage > 0) ? icon("increase") : icon("decrease")}</div><p className="xsmall-text regular-bold grey-600">{percentage}</p>
                    <DropdownButton
                        dropdown={dropdownOptions}
                        optionSelected={(id) => onSelectDropdown(id)}
                        content={icon("dots", 16)}
                        classButton="dropdown-kpi-btn"
                        classContent="dropdown-kpi-content"
                    />
                </div>
                <HorizontalLayout className="space-between">
                    <h2 className="module-value">{value} {unit && formatUnit(unit)}</h2>
                    <IconAtom2 onClick={onToggleGraph} style={{ backgroundColor: "transparent", }} color={isActive ? "error-500" : "success-500"} icon2={isActive ? "minus" : "plus"} />
                </HorizontalLayout>
            </div>
            {data}
        </div>
    )
}